export class Tab {
  constructor(
    public id: string,
    public name: string,
    public pill?: string,
    public disabled?: boolean,
    public icon?: string
  ) { }
}
